import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

import InlineCode from "./icons/InlineCode.svg";

import type { DocumentModel } from "@/models/DocumentModel";

export const InlineCodeButton = observer(function InlineCodeButton({
  doc,
}: {
  doc: DocumentModel;
}) {
  const t = useTranslations("sidebar");
  const { tiptap, editorState } = doc.editor;

  if (!tiptap) {
    return null;
  }

  const handleOnClick = () => {
    tiptap.chain().focus().toggleCode().run();
  };

  return (
    <Sidebar.Button
      icon={<InlineCode className={twMerge(editorState.isCode && "[&>path]:stroke-icon-active")} />}
      title={t("textStyle.inlineCode")}
      onClick={handleOnClick}
      isActive={editorState.isCode}
      disabled={editorState.isExpression}
      hintKey="inlineCode"
      inverted
    />
  );
});
